/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Button Styling
   ========================================================================== */
.a-btn__icon--on-left {
  padding-right: 0.6875em;
  border-right: 1px solid var(--pacific-60);
  margin-right: 0.4375em;
}

.a-btn__icon--on-right {
  padding-left: 0.6875em;
  border-left: 1px solid var(--pacific-60);
  margin-left: 0.4375em;
}

.a-btn--secondary .a-btn__icon {
  border-color: var(--gray-40);
}
.a-btn--warning .a-btn__icon {
  border-color: var(--red-60);
}
.a-btn--disabled .a-btn__icon, .a-btn[disabled] .a-btn__icon {
  border-color: var(--gray-60);
}